import { render, staticRenderFns } from "./BetToolMenu.vue?vue&type=template&id=21fea89e&scoped=true&"
import script from "./BetToolMenu.vue?vue&type=script&lang=js&"
export * from "./BetToolMenu.vue?vue&type=script&lang=js&"
import style0 from "./BetToolMenu.vue?vue&type=style&index=0&id=21fea89e&prod&lang=css&"
import style1 from "./BetToolMenu.vue?vue&type=style&index=1&id=21fea89e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fea89e",
  null
  
)

export default component.exports